import React from 'react';

const Research = () => {
  return (
    <div className="section">
      <div className="container">
        <h1 className="section-title">Research</h1>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <p style={{ fontSize: '1.1rem', textAlign: 'center', marginBottom: '2rem' }}>
            Promoting clinical research and evidence-based practices in urological surgery.
          </p>
          
          <div style={{ textAlign: 'left', marginBottom: '3rem' }}>
            <h2 style={{ color: 'var(--primary-green)' }}>Research Initiatives</h2>
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li>Nigerian Urological Surgery Registry</li>
              <li>Clinical Trial Participation</li>
              <li>Epidemiological Studies</li>
              <li>Quality Improvement Projects</li>
              <li>International Collaboration Studies</li>
            </ul>
          </div>
          
          <div style={{ textAlign: 'left', marginBottom: '3rem' }}>
            <h2 style={{ color: 'var(--primary-green)' }}>Publications</h2>
            <p>
              Our members contribute to the 
              <a href="https://nju.org.ng/index.php/nju" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-green)', fontWeight: 'bold', marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                Nigerian Journal of Urology (NJU)
              </a>
              - the official journal of the Association of Urological Surgeons, Nigeria.
            </p>
            
            <h3 style={{ color: 'var(--primary-green)', marginTop: '1rem' }}>Recent Publications</h3>
            <p>Recent publications by NAUS members and collaborators:</p>
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li>"Prostate Cancer Trends in Nigeria: A 10-Year Analysis"</li>
              <li>"Minimally Invasive Surgery Outcomes in Nigerian Patients"</li>
              <li>"Pediatric Urological Conditions: A National Survey"</li>
              <li>"Robotic Surgery Adoption in Nigerian Hospitals"</li>
            </ul>
          </div>
          
          <div style={{ textAlign: 'left', marginBottom: '3rem' }}>
            <h2 style={{ color: 'var(--primary-green)' }}>Research Funding</h2>
            <p>NAUS provides research grants and funding opportunities for:</p>
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li>Young investigators</li>
              <li>Multi-center studies</li>
              <li>Translational research</li>
              <li>Global health initiatives</li>
            </ul>
          </div>
          
          <div style={{ textAlign: 'left', marginBottom: '3rem' }}>
            <h2 style={{ color: 'var(--primary-green)' }}>Collaboration Opportunities</h2>
            <p>We welcome partnerships with:</p>
            <ul style={{ paddingLeft: '1.5rem' }}>
              <li>International urological societies</li>
              <li>Academic institutions</li>
              <li>Medical device companies</li>
              <li>Pharmaceutical companies</li>
              <li>Government agencies</li>
            </ul>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <a 
              href="https://nju.org.ng/index.php/nju" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn"
              style={{ textDecoration: 'none' }}
            >
              Visit Journal Website
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Research;